import styled from '@emotion/styled';
import { Button } from '@mui/material';
import { ButtonProps } from '@mui/material';
import { media } from '@/styles/tokens';

export const Container = styled.section`
  background-color: #f9fafb;
`;
export const Inner = styled.div`
  padding: 130px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
  max-width: 1440px;
  width: 100%;

  ${media.mobile} {
    padding: 80px 20px;
    max-width: 375px;
  }
`;
export const Title = styled.h2`
  color: #121212;
  text-align: center;
  font-size: 36px;
  font-weight: 700;
  line-height: 48px;

  ${media.mobile} {
    font-size: 24px;
    line-height: 34px;
  }
`;
export const HighlightText = styled.strong`
  font-weight: 700;
  background: linear-gradient(to right, #3449ff 0%, #f86b3e 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;
export const Description = styled.p`
  margin: 33px 0 40px;
  color: #121212;
  font-size: 20px;
  font-weight: 500;
  line-height: 28px;

  ${media.mobile} {
    margin-bottom: 35px;
    text-align: center;
    font-size: 16px;
    line-height: 22px;
    letter-spacing: -0.48px;
    white-space: pre-line;
  }
`;
export const BtnContact = styled(Button)<ButtonProps>`
  margin-bottom: 80px;
  padding: 16px 32px;
  background-color: #3449ff;
  border-radius: 8px;
  color: #fff;
  font-size: 20px;
  font-weight: 700;
  line-height: 28px;

  ${media.mobile} {
    margin-bottom: 52px;
    padding: 13px 16px;
    width: calc(100% - 10px);
    font-size: 18px;
    font-weight: 500;
  }
`;
export const PlanImages = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;
